const react_frontend_url =
    process.env.REACT_BACKEND_URL || 'http://localhost:3000';
export { react_frontend_url };
